/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreatePayoutResponseStatus = typeof CreatePayoutResponseStatus[keyof typeof CreatePayoutResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePayoutResponseStatus = {
  requested: 'requested',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
  quoted: 'quoted',
  new: 'new',
} as const;
